module.exports = {
	"config": {
		"siteTitle": "Webdesign",
		"linkPrefix": "/webdesign.IAD"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "additions",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "additions",
				"stem": "index",
				"path": "additions/index.md"
			},
			"requirePath": "additions/index.md",
			"path": "/additions/",
			"data": {
				"title": "Additions · Notes"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "adressregister",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "adressregister",
				"stem": "index",
				"path": "adressregister/index.md"
			},
			"requirePath": "adressregister/index.md",
			"path": "/adressregister/",
			"data": {
				"title": "Aufgabe · Adressregister"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "architects",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "architects",
				"stem": "index",
				"path": "architects/index.md"
			},
			"requirePath": "architects/index.md",
			"path": "/architects/",
			"data": {
				"title": "Aufgabe · Architekten"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "browser",
				"base": "browserinfo.md",
				"ext": "md",
				"name": "browserinfo",
				"extname": ".md",
				"basename": "browserinfo.md",
				"dirname": "browser",
				"stem": "browserinfo",
				"path": "browser/browserinfo.md"
			},
			"requirePath": "browser/browserinfo.md",
			"path": "/browser/browserinfo/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "browser",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "browser",
				"stem": "index",
				"path": "browser/index.md"
			},
			"requirePath": "browser/index.md",
			"path": "/browser/",
			"data": {
				"title": "Browser"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "corporate",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "corporate",
				"stem": "index",
				"path": "corporate/index.md"
			},
			"requirePath": "corporate/index.md",
			"path": "/corporate/",
			"data": {
				"title": "Corporate Design"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "designprinciples",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "designprinciples",
				"stem": "index",
				"path": "designprinciples/index.md"
			},
			"requirePath": "designprinciples/index.md",
			"path": "/designprinciples/",
			"data": {
				"title": "Design-Paradigmen"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "device",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "device",
				"stem": "index",
				"path": "device/index.md"
			},
			"requirePath": "device/index.md",
			"path": "/device/",
			"data": {
				"title": "Aufgabe · Gerät"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "embedding",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "embedding",
				"stem": "index",
				"path": "embedding/index.md"
			},
			"requirePath": "embedding/index.md",
			"path": "/embedding/",
			"data": {
				"title": "Einbinden von externen Inhalten"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fontrendering",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fontrendering",
				"stem": "index",
				"path": "fontrendering/index.md"
			},
			"requirePath": "fontrendering/index.md",
			"path": "/fontrendering/",
			"data": {
				"title": "Fontdarstellung"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fonts",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fonts",
				"stem": "index",
				"path": "fonts/index.md"
			},
			"requirePath": "fonts/index.md",
			"path": "/fonts/",
			"data": {
				"title": "Fonts"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "fontvorstellung",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "fontvorstellung",
				"stem": "index",
				"path": "fontvorstellung/index.md"
			},
			"requirePath": "fontvorstellung/index.md",
			"path": "/fontvorstellung/",
			"data": {
				"title": "Aufgabe · Fontvorstellung"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "grid",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "grid",
				"stem": "index",
				"path": "grid/index.md"
			},
			"requirePath": "grid/index.md",
			"path": "/grid/",
			"data": {
				"title": "Gestaltung · Layout und Raster"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "html1x1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "html1x1",
				"stem": "index",
				"path": "html1x1/index.md"
			},
			"requirePath": "html1x1/index.md",
			"path": "/html1x1/",
			"data": {
				"title": "Technologie · HTML, CSS & JavaScript"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md"
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {
				"title": "Inhalt"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "interaction",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "interaction",
				"stem": "index",
				"path": "interaction/index.md"
			},
			"requirePath": "interaction/index.md",
			"path": "/interaction/",
			"data": {
				"title": "Interaktion mit Inhalten"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "interaction",
				"base": "straftaten.md",
				"ext": "md",
				"name": "straftaten",
				"extname": ".md",
				"basename": "straftaten.md",
				"dirname": "interaction",
				"stem": "straftaten",
				"path": "interaction/straftaten.md"
			},
			"requirePath": "interaction/straftaten.md",
			"path": "/interaction/straftaten/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "interface",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "interface",
				"stem": "index",
				"path": "interface/index.md"
			},
			"requirePath": "interface/index.md",
			"path": "/interface/",
			"data": {
				"title": "Gestaltung · Geräte und deren Bedienung"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "interface",
				"base": "smartphoneinfo.md",
				"ext": "md",
				"name": "smartphoneinfo",
				"extname": ".md",
				"basename": "smartphoneinfo.md",
				"dirname": "interface",
				"stem": "smartphoneinfo",
				"path": "interface/smartphoneinfo.md"
			},
			"requirePath": "interface/smartphoneinfo.md",
			"path": "/interface/smartphoneinfo/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "interface",
				"base": "speedinfo.md",
				"ext": "md",
				"name": "speedinfo",
				"extname": ".md",
				"basename": "speedinfo.md",
				"dirname": "interface",
				"stem": "speedinfo",
				"path": "interface/speedinfo.md"
			},
			"requirePath": "interface/speedinfo.md",
			"path": "/interface/speedinfo/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "navigation",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "navigation",
				"stem": "index",
				"path": "navigation/index.md"
			},
			"requirePath": "navigation/index.md",
			"path": "/navigation/",
			"data": {
				"title": "Navigations- und Ordnungskonzepte"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "paperprototype",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "paperprototype",
				"stem": "index",
				"path": "paperprototype/index.md"
			},
			"requirePath": "paperprototype/index.md",
			"path": "/paperprototype/",
			"data": {
				"title": "Gestaltung · Paperprototype"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "react.js",
				"ext": "js",
				"name": "react",
				"extname": ".js",
				"basename": "react.js",
				"dirname": "",
				"stem": "react",
				"path": "react.js"
			},
			"requirePath": "react.js",
			"path": "/react/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "responsive",
				"base": "deviceinfo.md",
				"ext": "md",
				"name": "deviceinfo",
				"extname": ".md",
				"basename": "deviceinfo.md",
				"dirname": "responsive",
				"stem": "deviceinfo",
				"path": "responsive/deviceinfo.md"
			},
			"requirePath": "responsive/deviceinfo.md",
			"path": "/responsive/deviceinfo/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "responsive",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "responsive",
				"stem": "index",
				"path": "responsive/index.md"
			},
			"requirePath": "responsive/index.md",
			"path": "/responsive/",
			"data": {
				"title": "Responsive Design"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "servertechnology",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "servertechnology",
				"stem": "index",
				"path": "servertechnology/index.md"
			},
			"requirePath": "servertechnology/index.md",
			"path": "/servertechnology/",
			"data": {
				"title": "Services & Server"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "shop",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "shop",
				"stem": "index",
				"path": "shop/index.md"
			},
			"requirePath": "shop/index.md",
			"path": "/shop/",
			"data": {
				"title": "Aufgabe · Shop"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "tools",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "tools",
				"stem": "index",
				"path": "tools/index.md"
			},
			"requirePath": "tools/index.md",
			"path": "/tools/",
			"data": {
				"title": "Redaktions- und Autoren-Tools (CMS)"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "typography",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "typography",
				"stem": "index",
				"path": "typography/index.md"
			},
			"requirePath": "typography/index.md",
			"path": "/typography/",
			"data": {
				"title": "Detailtypografie & Mengentext"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "wiki",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "wiki",
				"stem": "index",
				"path": "wiki/index.md"
			},
			"requirePath": "wiki/index.md",
			"path": "/wiki/",
			"data": {
				"title": "Aufgabe · Wikipedia-Artikel"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "ziele",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "ziele",
				"stem": "index",
				"path": "ziele/index.md"
			},
			"requirePath": "ziele/index.md",
			"path": "/ziele/",
			"data": {
				"title": "Ziele & Zeit"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 406
// module chunks = 0